import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import useTheme from "@mui/material/styles/useTheme";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import background from "../../../assets/birds.png";
import Main from "../Common/Main";

const PARAGRAPH_STYLES: React.CSSProperties = {
  maxWidth: "500px",
  lineHeight: 1.5,
  fontFamily: "charter",
  fontSize: ".8em",
};

export default function AboutMe() {
  const theme = useTheme();
  const smBreakPoint = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Main>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <Stack
          style={{
            fontSize: "20px",
            gap: "10px",
          }}
        >
          <Box
            sx={{
              minWidth: smBreakPoint ? "500px" : "300px",
            }}
          >
            <span
              style={{
                color: "rgb(65, 10, 10)",
                fontSize: "2.5em",
              }}
            >
              ABOUT ME
            </span>
          </Box>
          <Typography variant="body1" sx={{ ...PARAGRAPH_STYLES }}>
            Hello 👋 my name is{" "}
            <span style={{ fontWeight: "bold" }}>Swan Toma</span>. I'm a
            Software Engineer living in San Diego, CA. I've been working remote
            most of my career. My experience covers front-end web development,
            back-end (APIs, services, databases), and infrastructure (AWS).
          </Typography>
          <Typography variant="body1" sx={{ ...PARAGRAPH_STYLES }}>
            I've built a library section on this site if you're interested in
            new reads. It's my little corner of the Internet where I can revisit
            and share some of my favorite reads.
          </Typography>
          <Typography variant="body1" sx={{ ...PARAGRAPH_STYLES }}>
            The code for the website can be found in my Github. It's made using
            React & Material UI and deployed through Cloudflare.
          </Typography>
          <Typography sx={{ ...PARAGRAPH_STYLES }}>
            Thank you for visting!
          </Typography>
          {/* <AvatarRow fillColor="#22311d" fontSize="large" /> */}
        </Stack>
        {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Picture />
          </Box> */}
        {/* </Stack> */}
      </Box>
    </Main>
  );
}
